document.addEventListener('DOMContentLoaded',function(){
  const toggle=document.querySelector('.arcta-menu-toggle');
  const drawer=document.querySelector('.arcta-drawer');
  const backdrop=document.querySelector('.arcta-backdrop');
  const help=document.querySelector('.arcta-help-toggle');
  const helpLinks=document.querySelector('.arcta-help-links');
  function closeDrawer(){
    if(!toggle||!drawer||!backdrop)return;
    drawer.classList.remove('is-open');backdrop.classList.remove('is-visible');
    drawer.setAttribute('aria-hidden','true');toggle.setAttribute('aria-expanded','false');
    toggle.setAttribute('aria-label','Open menu');document.body.classList.remove('arcta-menu-open');
    toggle.innerHTML='<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M2 5h20M2 12h20M2 19h20"></path></svg>';
  }
  function openDrawer(){
    drawer.classList.add('is-open');backdrop.classList.add('is-visible');
    drawer.setAttribute('aria-hidden','false');toggle.setAttribute('aria-expanded','true');
    toggle.setAttribute('aria-label','Close menu');document.body.classList.add('arcta-menu-open');
    toggle.innerHTML='<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M4 4l16 16M20 4L4 20"></path></svg>';
  }
  if(toggle&&drawer&&backdrop){
    toggle.addEventListener('click',()=>drawer.classList.contains('is-open')?closeDrawer():openDrawer());
    backdrop.addEventListener('click',closeDrawer);
    document.addEventListener('keydown',e=>{if(e.key==='Escape')closeDrawer()});
  }
  if(help&&helpLinks){help.addEventListener('click',()=>{const expanded=help.getAttribute('aria-expanded')==='true';help.setAttribute('aria-expanded',String(!expanded));helpLinks.classList.toggle('is-open',!expanded);});}
});